export const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));

const adjustHexColor = (hex: string, amount: number): string => {
  const normalized = hex.startsWith('#') ? hex.slice(1) : hex;
  const expanded = normalized.length === 3 ? normalized.split('').map((char) => char + char).join('') : normalized;

  const numeric = parseInt(expanded, 16);
  const r = clamp(((numeric >> 16) & 0xff) + amount, 0, 255);
  const g = clamp(((numeric >> 8) & 0xff) + amount, 0, 255);
  const b = clamp((numeric & 0xff) + amount, 0, 255);

  const toHex = (value: number) => value.toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const lightenHexColor = (hex: string, amount: number): string => adjustHexColor(hex, Math.abs(amount));

export const darkenHexColor = (hex: string, amount: number): string => adjustHexColor(hex, -Math.abs(amount));

export const hexToRgba = (hex: string, alpha: number): string => {
  const normalized = hex.replace('#', '');
  if (normalized.length !== 6) {
    return hex;
  }
  const bigint = parseInt(normalized, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
